
export default function CTASection() {
  return (
    <section className="py-16 bg-gradient-to-r from-[#BF0000] to-[#E60000] relative overflow-hidden">
      {/* 装飾的な背景要素 */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-32 h-32 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 relative z-10">
        {/* 限定感ブロック */}
        <div className="bg-[#FFD700] text-[#BF0000] px-6 py-3 rounded-full inline-block mb-6 font-bold text-sm animate-pulse">
          <i className="ri-time-line mr-2"></i>
          今だけ！新規入会キャンペーン実施中
        </div>

        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            今すぐ大手ECモール系カードに申し込む
          </h2>
          
          {/* キャンペーン情報 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 mb-6 border-2 border-white/30">
            <div className="flex items-center justify-center gap-3 mb-4">
              <i className="ri-gift-line text-4xl text-[#FFD700]"></i>
              <div className="text-left">
                <p className="text-white/90 text-sm">新規入会&利用特典</p>
                <p className="text-3xl font-bold text-white">最大8,000ポイント</p>
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
              <div className="bg-white/10 rounded-lg p-3">
                <p className="text-[#FFD700] font-bold mb-1">特典①</p>
                <p className="text-white">新規入会で<br />2,000ポイント</p>
              </div>
              <div className="bg-white/10 rounded-lg p-3">
                <p className="text-[#FFD700] font-bold mb-1">特典②</p>
                <p className="text-white">カード利用で<br />3,000ポイント</p>
              </div>
              <div className="bg-white/10 rounded-lg p-3">
                <p className="text-[#FFD700] font-bold mb-1">特典③</p>
                <p className="text-white">ECモール利用で<br />3,000ポイント</p>
              </div>
            </div>
          </div>

          <a
            href="https://www.rakuten-card.co.jp/campaign/rakuten_card/affiliate/a.html"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#DC2626] hover:bg-[#B91C1C] text-white font-bold px-12 py-5 rounded-full transition-all duration-300 shadow-2xl hover:shadow-3xl hover:scale-105 whitespace-nowrap cursor-pointer text-lg md:text-xl mb-4"
          >
            <i className="ri-external-link-line text-xl"></i>
            公式サイトで今すぐ申し込む（PR）
          </a>

          {/* 安心ポイント */}
          <div className="flex flex-wrap justify-center gap-4 text-white/90 text-sm mb-4">
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-[#FFD700]"></i>
              <span>年会費永年無料</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-[#FFD700]"></i>
              <span>審査最短数分</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-[#FFD700]"></i>
              <span>ポイント還元率1.0%</span>
            </div>
          </div>

          <p className="text-white/70 text-xs">
            ※キャンペーンは予告なく変更・終了する場合があります
          </p>
        </div>
      </div>
    </section>
  );
}
